const EXCLUDED_KEYS = new Set([
  'url',
  'qualifier',
  'variantType',
  'attachmentTechName',
  'attachmentProductCode',
  'attachmentUpgradeCode',
  'attachmentExtension',
  'attachmentType',
  'productId',
]);

// UUID v4 check — only run when the string is exactly 36 chars to avoid unnecessary regex on every string
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Recursively extracts all meaningful text from an arbitrary object for search indexing.
 *
 * Excluded:
 * - boolean and number values (not human-searchable)
 * - empty / whitespace-only strings
 * - URLs (strings containing http:// or https://)
 * - UUIDs (36-char strings matching UUID v4 format)
 * - a fixed set of technical key names (see EXCLUDED_KEYS)
 */
export function extractSearchText(obj: unknown): string {
  if (obj === null || obj === undefined) return '';
  if (typeof obj === 'boolean' || typeof obj === 'number') return '';

  if (typeof obj === 'string') {
    const trimmed = obj.trim();
    if (!trimmed) return '';
    if (trimmed.includes('http://') || trimmed.includes('https://')) return '';
    if (trimmed.length === 36 && UUID_RE.test(trimmed)) return '';
    return trimmed;
  }

  if (Array.isArray(obj)) {
    return obj.map(extractSearchText).filter(Boolean).join(' ');
  }

  if (typeof obj === 'object') {
    return Object.entries(obj as Record<string, unknown>)
      .filter(([key]) => !EXCLUDED_KEYS.has(key))
      .map(([, val]) => extractSearchText(val))
      .filter(Boolean)
      .join(' ');
  }

  return '';
}
